/**
 * Firebase Storage helpers.
 * Single upload/download interface — no duplicate GCS helpers.
 */
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  type UploadTask,
  type StorageReference,
} from "firebase/storage";
import app from "./client";

export const storage = getStorage(app);

/**
 * Upload a file with progress tracking.
 * Returns an UploadTask so callers can subscribe to progress events.
 *
 * Path convention: `{userId}/{folder}/{filename}`
 */
export function uploadFile(path: string, file: File): UploadTask {
  const storageRef: StorageReference = ref(storage, path);
  return uploadBytesResumable(storageRef, file, {
    contentType: file.type,
  });
}

/**
 * Resolves the public download URL for a storage path.
 */
export async function getFileUrl(path: string): Promise<string> {
  const storageRef = ref(storage, path);
  return getDownloadURL(storageRef);
}

/**
 * Deletes a file at the given storage path.
 */
export async function deleteFile(path: string): Promise<void> {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
}
